<span class="loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header></app-header>
<app-side-menu-bar></app-side-menu-bar>
<div class="leftMargin" *ngIf="!noRecordsShow">
    <div class="cellText">
        <span>Selected File Name : </span>
    </div>
    <div class="cellLarge">
        <span> {{ fileName }} </span>
    </div>

    <div class="cellTextSmall">
        <span> Uploaded By : </span>
    </div>
    <div class="cellTextName">
        <span> {{ uploadedBy }} </span>
    </div>

    <div class="cellTextSmall">
        <span> Uploaded Date : </span>
    </div>
    <div class="cellTextDate">
        <span> {{ uploadedDate }} </span>
    </div>
    <div class="cellbutton">
        <button type="button" class="delete-button"  (click)="deleteData()">
             Delete
        </button>
    </div>
    <div class="cellbutton">
        <button type="button" class="delete-button"  (click)="loadDataUploadPage()">
             Back
        </button>
    </div>
</div>

<div [ngClass]="'initialPosition'">
    <div *ngIf="noRecordsShow" class="records">{{noRecords}}</div>
    <div class="example-container mat-elevation-z8" [ngClass]="'newHeight'" *ngIf="!noRecordsShow">
        <table mat-table [dataSource]="dataSource" *ngIf="!noRecordsShow">
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
            
            <ng-container matColumnDef="Select">
                <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> 
                    Select<br><input type="checkbox" [(ngModel)]="isMasterSel" class="checkboxalignment" (change)="checkUncheckAll()"/>
                </th>
                <td class="centerDataCell" mat-cell *matCellDef="let element">
                    <input type="checkbox" [(ngModel)]="element.isselected" (change)="isAllSelected()"/>
                </td>
            </ng-container>
                  
            <!-- Production Date Column -->
            <ng-container matColumnDef="PRODUCTIONDATE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Production Date </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.productiondate}} </td>
            </ng-container>

            <!-- Product Code Column -->
            <ng-container matColumnDef="PRODUCTCODE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product Code </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element">
                    <span>{{element.productcode}}</span>
                </td>
            </ng-container>

            <!-- Product Description Column -->
            <ng-container matColumnDef="PRODUCTDESCRIPTION">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product Description </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element">
                    <span>{{element.productdescription}}</span>
                </td>
            </ng-container>

            <!-- CLUSTER Column -->
            <ng-container matColumnDef="CLUSTER">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Cluster </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.cluster}} </td>
            </ng-container>

            <!-- Defect Mode Aggregation Column -->
            <ng-container matColumnDef="DEFECTMODEAGGREGATION">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Defect Mode Aggregation </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.defectmodeaggregation}} </td>
            </ng-container>

            <!-- BIGCATEGORY Column -->
            <ng-container matColumnDef="BIGCATEGORY">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Big Category </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.bigcategory}} </td>
            </ng-container>

            <!-- SUBCATEGORY Column -->
            <ng-container matColumnDef="SUBCATEGORY">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Sub Category </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.subcategory}} </td>
            </ng-container>

            <!-- PRODUCT Column -->
            <!-- <ng-container matColumnDef="PRODUCT">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Product</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.product}} </td>
            </ng-container> -->
            <!-- RecordID Column -->
            <ng-container matColumnDef="RECORDID">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>RecordID</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.recordid}} </td>
            </ng-container>
            
            <ng-container matColumnDef="FORMATSIZE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Format Size </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element">
                    {{ element.formatsize }}
                </td>
            </ng-container>

            <!-- LOSSTREE Column -->
            <ng-container matColumnDef="LOSSTREE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>LossTree</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.losstree}} </td>
            </ng-container>
            <!-- LEVEL0 Column -->
            <ng-container matColumnDef="LEVEL0">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Level0</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL0}} </td>
            </ng-container>
            <!-- LEVEL1 Column -->
            <ng-container matColumnDef="LEVEL1">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Level1</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL1}} </td>
            </ng-container>
            <!-- LEVEL2 Column -->
            <ng-container matColumnDef="LEVEL2">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Level2</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL2}} </td>
            </ng-container>
            <!-- LEVEL3 Column -->
            <ng-container matColumnDef="LEVEL3">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Level3</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL3}} </td>
            </ng-container>
            <!-- LEVEL4 Column -->
            <ng-container matColumnDef="LEVEL4">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Level4</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL4}} </td>
            </ng-container>
            <!-- LEVEL5 Column -->
            <ng-container matColumnDef="LEVEL5">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Level5</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL5}} </td>
            </ng-container>
            <!-- DEFECTSEVERITYGRADE Column -->
            <ng-container matColumnDef="DEFECTSEVERITYGRADE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Defect Severity Grade</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.defectseveritygrade}} </td>
            </ng-container>
             <!-- PRODUCTIONLINE Column -->
             <ng-container matColumnDef="PRODUCTIONLINE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Production Line</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.productionline}} </td>
            </ng-container>
            <!-- NOOFBLOCKEDPRODUCT Column -->
            <ng-container matColumnDef="NOOFBLOCKEDPRODUCT">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>No of Blocked Product</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.noofblockedproduct}} </td>
            </ng-container>
            <!-- AVERAGEBATCHQTY Column -->
            <ng-container matColumnDef="AVERAGEBATCHQTY">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Average Batch Qty</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.averagebatchqty}} </td>
            </ng-container>
            <!-- UOM Column -->
            <ng-container matColumnDef="UOM">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Uom</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.uom}} </td>
            </ng-container>
            <!-- AFFECTEDPRODUCTPERCENTAGE Column -->
            <ng-container matColumnDef="AFFECTEDPRODUCTPERCENTAGE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Affected Product Percentage</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.affectedproductpercentage}} </td>
            </ng-container>
            <!-- FREQUENCYSCORE Column -->
            <ng-container matColumnDef="FREQUENCYSCORE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Frequency Score</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.frequencyscore}} </td>
            </ng-container>
            <!-- PROCESSPOINT Column -->
            <ng-container matColumnDef="PROCESSPOINT">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Process Point</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.processpoint}} </td>
            </ng-container>
            <!-- FOURMS Column -->
            <ng-container matColumnDef="FOURMS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>FourMs</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.fourms}} </td>
            </ng-container>
            <!-- DETECTIONPOINT Column -->
            <ng-container matColumnDef="DETECTIONPOINT">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Detection Point</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.detectionpoint}} </td>
            </ng-container>
            <!-- DETECTABILITY Column -->
            <ng-container matColumnDef="DETECTABILITY">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Detectability</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.detectability}} </td>
            </ng-container>
            <!-- EINCIDENT Column -->
            <ng-container matColumnDef="EINCIDENT">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>EIncident</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.eincident}} </td>
            </ng-container>
            <!-- REWORK Column -->
            <ng-container matColumnDef="REWORK">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Rework</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.rework}} </td>
            </ng-container>
            <!-- AMBERCRQS Column -->
            <ng-container matColumnDef="AMBERCRQS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Amber CRQS</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.ambercrqs}} </td>
            </ng-container>
            <!-- QUALITYRELATEDWASTE Column -->
            <ng-container matColumnDef="QUALITYRELATEDWASTE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Quality Related Waste</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.qualityrelatedwaste}} </td>
            </ng-container>
            <!-- DINCIDENTS Column -->
            <ng-container matColumnDef="DINCIDENTS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>D-Incidents</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.dincidents}} </td>
            </ng-container>
            <!-- PALLETNONCONFORMANCE Column -->
            <ng-container matColumnDef="PALLETNONCONFORMANCE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Pallet Non-Conformance</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.palletnonconformance}} </td>
            </ng-container>
            <!-- CUSTOMERNONCONFORMANCE Column -->
            <ng-container matColumnDef="CUSTOMERNONCONFORMANCE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Customer Non-Conformance</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.customernonconformance}} </td>
            </ng-container>
            <!-- ONSHELFCRQS Column -->
            <ng-container matColumnDef="ONSHELFCRQS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Onshelf CRQS</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.onshelfcrqs}} </td>
            </ng-container>
            <!-- CONSUMERCOMPLAINTS Column -->
            <ng-container matColumnDef="CONSUMERCOMPLAINTS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Consumer Complaints</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.consumercomplaints}} </td>
            </ng-container>
            <!-- MARKETPLACEINCIDENT Column -->
            <ng-container matColumnDef="MARKETPLACEINCIDENT">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Market Place Incident</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.marketplaceincident}} </td>
            </ng-container>
            <!-- COSTOF1PC Column -->
            <ng-container matColumnDef="COSTOF1PC">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Cost of 1pc</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.costof1pc}} </td>
            </ng-container>
            <!-- TOTALDEFECTCOST Column -->
            <ng-container matColumnDef="TOTALDEFECTCOST">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Total Defect Cost</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.totaldefectcost}} </td>
            </ng-container>
            <!-- TOTALCOSTPERCENTAGE Column -->
            <ng-container matColumnDef="TOTALCOSTPERCENTAGE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Total Cost Percentage</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.totalcostpercentage}} </td>
            </ng-container>
            <!-- COSTSCORE Column -->
            <ng-container matColumnDef="COSTSCORE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Cost Score</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.costscore}} </td>
            </ng-container>
            <!-- DETECTABILITYINDEX Column -->
            <ng-container matColumnDef="DETECTABILITYINDEX">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Detectability Index</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.detectabilityindex}} </td>
            </ng-container>
            <!-- SEVERITYINDEX Column -->
            <ng-container matColumnDef="SEVERITYINDEX">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Severity Index</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.severityindex}} </td>
            </ng-container>
            <!-- FREQUENCYINDEX Column -->
            <ng-container matColumnDef="FREQUENCYINDEX">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Frequency Index</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.frequencyindex}} </td>
            </ng-container>
            <!-- COSTINDEX Column -->
            <ng-container matColumnDef="COSTINDEX">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Cost Index</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.costindex}} </td>
            </ng-container>
            <!-- DEFECTPRIORITYINDEX Column -->
            <ng-container matColumnDef="DEFECTPRIORITYINDEX">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Defect Priority Index</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindex}} </td>
            </ng-container>
            <!-- DPIVSTOTALDPIPERCENTAGE Column -->
            <ng-container matColumnDef="DPIVSTOTALDPIPERCENTAGE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>DPI Vs Total DPI Percentage</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.dpivstotaldpipercentage}} </td>
            </ng-container>
            <!-- CUMMULATIVEDPI Column -->
            <ng-container matColumnDef="CUMMULATIVEDPI">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Cummulative DPI</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.cummulativedpi}} </td>
            </ng-container>
            <!-- DPIDEFECTCLASS Column -->
            <ng-container matColumnDef="DPIDEFECTCLASS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>DPI Defect Class</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.dpidefectclass}} </td>
            </ng-container>
            <!-- MAN Column -->
            <ng-container matColumnDef="MAN">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Man</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.man}} </td>
            </ng-container>
            <!-- MACHINE Column -->
            <ng-container matColumnDef="MACHINE">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Machine</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.machine}} </td>
            </ng-container>
            <!-- METHOD Column -->
            <ng-container matColumnDef="METHOD">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Method</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.method}} </td>
            </ng-container>
            <!-- MATERIAL Column -->
            <ng-container matColumnDef="MATERIAL">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Material</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.material}} </td>
            </ng-container>
            <!-- PDCASTATUS Column -->
            <ng-container matColumnDef="PDCASTATUS">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>PDCA Status</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.pdcastatus}} </td>
            </ng-container>
            <!-- SITES Column -->
            <ng-container matColumnDef="SITES">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Sites</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.sites}} </td>
            </ng-container>
            <!-- LOCALCURRENCY Column -->
            <ng-container matColumnDef="LOCALCURRENCY">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef>Local Currency</th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.localcurrency}} </td>
            </ng-container>
            <!-- TOTALDEFECTCOSTEURO Column -->
            <ng-container matColumnDef="TOTALDEFECTCOSTEURO">
                <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef>Total Defect Cost in Euro</th>
                <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.totaldefectcosteuro}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<div class="alert alert-success successMsg successMessage" *ngIf="showSuccess">
    {{recordDeleted}}
  </div>
  <div class="alert alert-danger failMsg" *ngIf="showErrorMessage">
    {{errorMsg}}
  </div>